import { render } from "./Statuses.vue?vue&type=template&id=a8dc44b2&ts=true"
import script from "./Statuses.vue?vue&type=script&lang=ts"
export * from "./Statuses.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Vue\\donaska-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__